// icons/aliases.ts
import type { IconToken } from './types';

export const ALIASES: Partial<Record<IconToken, IconToken>> = {
  // ejemplo: 'default' podría apuntar a 'info'
  default: 'info',
};
